/* ----------------------
   SWIPER PRODUCT
---------------------- */
window.ProductGallery = {
  init(section) {
    const root = section || document;

    root.querySelectorAll(".main-product").forEach((productSection) => {
      const gallery = productSection.querySelector(".swiper-product-images");
      const thumbs = productSection.querySelector(".swiper-product-thumbs");

      if (!gallery || gallery.swiper) return;

      let thumbsSwiper = null;

      if (thumbs) {
        thumbsSwiper = new Swiper(thumbs, {
          slidesPerView: "auto",
          spaceBetween: 7,
          watchSlidesProgress: true,
          freeMode: true,
        });
      }

      const gallerySwiper = new Swiper(gallery, {
        slidesPerView: 1,
        speed: 450,
        watchOverflow: true,
        navigation: {
          nextEl: productSection.querySelector(".swiper-product-images-next"),
          prevEl: productSection.querySelector(".swiper-product-images-prev"),
        },
        pagination: {
          el: productSection.querySelector(".product__media-pagination"),
          clickable: true,
        },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      });

      productSection.productGallery = gallerySwiper;
    });
  },

  showMedia(mediaId) {
    if (!mediaId) return;

    document.querySelectorAll(".main-product").forEach((productSection) => {
      const target = productSection.querySelector(`[data-media="${mediaId}"]`);
      const swiper = productSection.productGallery;

      if (target && swiper) swiper.slideTo(Array.from(target.parentElement.children).indexOf(target));
    });
  },
};

const ProductVariants = {
  init(section) {
    const root = section || document;

    root.querySelectorAll(".attributes-values").forEach((variantGroup) => {
      const trigger = variantGroup.querySelector(".attributes__title");

      if (!trigger || trigger.dataset.variantToggleReady) return;

      trigger.dataset.variantToggleReady = "true";
      trigger.addEventListener("click", () => variantGroup.classList.toggle("open"));
    });
  },
};

const ProductAccordions = {
  init(section) {
    const root = section || document;

    root.querySelectorAll(".product__accordions").forEach((accordionGroup) => {
      const items = Array.from(accordionGroup.querySelectorAll(".product__accordion"));

      if (!items.length || accordionGroup.dataset.accordionReady) return;

      accordionGroup.dataset.accordionReady = "true";

      items.forEach((item) => {
        const trigger = item.querySelector(".product__accordion__title");
        const body = item.querySelector(".product__accordion__body");
        const inner = item.querySelector(".product__accordion__content");

        if (!trigger || !body || !inner) return;

        item.classList.remove("open");
        trigger.setAttribute("aria-expanded", "false");
        body.style.height = "0px";

        trigger.addEventListener("click", () => {
          if (item.classList.contains("open")) {
            item.classList.remove("open");
            trigger.setAttribute("aria-expanded", "false");
            body.style.height = "0px";
            return;
          }

          item.classList.add("open");
          trigger.setAttribute("aria-expanded", "true");
          body.style.height = `${inner.offsetHeight}px`;
        });
      });

      accordionGroup.querySelectorAll(".product-full-ingredients").forEach((fullIngredients) => {
        const trigger = fullIngredients.querySelector(".product-full-ingredients__title");
        const body = fullIngredients.querySelector(".product-full-ingredients__body");
        const inner = fullIngredients.querySelector(".product-full-ingredients__content");

        if (!trigger || !body || !inner) return;

        trigger.addEventListener("click", () => {
          const isOpen = fullIngredients.classList.toggle("open");
          const parentItem = fullIngredients.closest(".product__accordion");
          const parentBody = parentItem?.querySelector(":scope > .product__accordion__body");
          const previousBodyHeight = body.offsetHeight;
          const nextBodyHeight = isOpen ? inner.offsetHeight : 0;

          trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
          body.style.height = `${nextBodyHeight}px`;

          if (parentItem?.classList.contains("open") && parentBody) {
            parentBody.style.height = `${parentBody.offsetHeight + nextBodyHeight - previousBodyHeight}px`;
          }
        });
      });
    });
  },
};

const StickyBackInStock = {
  observer: null,

  init() {
    const stickySection = document.querySelector(".product-sticky-bar-section");
    const stickyNotify = stickySection?.querySelector("[data-sticky-notify]");

    if (!stickySection || !stickyNotify) return;

    const syncAvailability = (available) => {
      stickySection.classList.toggle("is-unavailable", !available);
    };

    const mountButton = () => {
      const notifyButton = document.querySelector(".email-me-button.email-me-floatButton");

      if (!notifyButton) {
        stickySection.classList.remove("has-notify-button");
        return;
      }

      if (notifyButton.parentElement !== stickyNotify) {
        stickyNotify.appendChild(notifyButton);
      }

      stickySection.classList.add("has-notify-button");
    };

    syncAvailability(!stickySection.querySelector(".product__sticky-button")?.classList.contains("product-unavailable"));
    mountButton();

    if (!this.observer) {
      this.observer = new MutationObserver(mountButton);
      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    if (!stickySection.dataset.backInStockReady) {
      stickySection.dataset.backInStockReady = "true";
      document.addEventListener("variant:change", (event) => {
        syncAvailability(Boolean(event.detail?.variant?.available));
        mountButton();
      });
    }
  },
};

/*----------------------
 STICKY
 ----------------------*/
Sticky = {
  init: function () {
    const purchase = document.querySelector(".product__purchase");
    const stickyBar = document.querySelector(".product-sticky-bar-section");

    function sticky() {
      var height_div = $(".product__media").outerHeight();
      var height_window = $(window).height();

      if (height_div > height_window) {
        var result = height_div - height_window;
        $(".product__media").css("top", -result);
      } else {
        $(".product__media").css("top", "62px");
      }
    }
    sticky();

    $(window).on("resize", function () {
      sticky();
    });

    if (!purchase || !stickyBar || purchase.dataset.stickyObserverReady) return;

    purchase.dataset.stickyObserverReady = "true";

    const purchaseObserver = new IntersectionObserver(
      ([entry]) => {
        const hasExitedAbove = !entry.isIntersecting && entry.boundingClientRect.bottom <= 130;
        stickyBar.classList.toggle("visible", hasExitedAbove);
      },
      {
        rootMargin: "-130px 0px 0px 0px",
        threshold: 0,
      }
    );

    purchaseObserver.observe(purchase);
  }
};



document.addEventListener("DOMContentLoaded", () => {
  window.ProductGallery.init(document);
  ProductVariants.init(document);
  ProductAccordions.init(document);
  StickyBackInStock.init();
  Sticky.init(document);
});

document.addEventListener("shopify:section:load", (event) => {
  window.ProductGallery.init(event.target);
  ProductVariants.init(event.target);
  ProductAccordions.init(event.target);
  StickyBackInStock.init();
  Sticky.init();
});
